import { Box, Button, Menu, MenuItem, SxProps, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { SelectProps } from 'app/constants/types';
import CheckmarkIcon from '../Icons/CheckmarkIcon';
import ChevronDownIcon from '../Icons/ChevronDownIcon';
import FlagIcon from '../Icons/FlagIcon';

import { useLanguageSwitcher } from 'app/components/LanguageSwitcher/useLanguageSwitcher';

import {
  languageButton,
  languageButtonCompact,
  languageLabel,
  languageMenuItem,
  languageMenuLabel,
  languageMenuPaper,
  languageMenuPaperCompact,
  languageValue,
} from './LanguageSwitcher.sx';

interface Props {
  homePage?: boolean;
  isSelect?: boolean;
  /** Show only the flag (hides the language label and chevron) — used in the mobile header */
  compact?: boolean;
}

const languages: SelectProps[] = [
  {
    key: 0,
    value: 'az',
    label: 'AZ',
  },
  {
    key: 1,
    value: 'en',
    label: 'EN',
  },
  {
    key: 2,
    value: 'ru',
    label: 'RU',
  },
];

const LanguageSwitcher = (props: Props) => {
  const { homePage, compact } = props;
  const { path, data, changeLanguageNavLink, anchorEl, handleClose, open, lang, handleClick } =
    useLanguageSwitcher({
      homePage,
    });

  return (
    <>
      <Box>
        <Button
          variant={'text'}
          aria-controls={open ? 'lang-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={[languageButton, ...(compact ? [languageButtonCompact] : [])] as SxProps}
          disableRipple
        >
          <Box sx={languageValue}>
            <FlagIcon lang={lang ?? 'az'} />
            {!compact && <Typography sx={languageLabel}>{lang?.toUpperCase()}</Typography>}
          </Box>
          {!compact && (
            <ChevronDownIcon
              sx={{
                transform: open ? 'rotate(180deg)' : 'none',
                transition: 'transform 0.2s',
              }}
            />
          )}
        </Button>
        <Menu
          id='lang-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{
            sx: [languageMenuPaper, ...(compact ? [languageMenuPaperCompact] : [])] as SxProps,
          }}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {languages.map(item => (
            <MenuItem
              key={item.key}
              component={NavLink}
              to={`/${item.value}${path}`}
              onClick={() => {
                changeLanguageNavLink(item);
                handleClose();
              }}
              sx={languageMenuItem}
            >
              <FlagIcon lang={item.value} />
              <Typography sx={languageMenuLabel}>{item.label}</Typography>
              {lang === item.value && <CheckmarkIcon />}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </>
  );
};

export default LanguageSwitcher;
